import React, { useState, useEffect } from 'react';
import { TIMEZONE_OPTIONS, getUserTimezone, setUserTimezone } from '../utils/userTimezone';

/**
 * Settings-menu or form control: choose IANA zone or browser default.
 * Stops propagation so parent dropdown menus stay open until blur.
 */
export default function UserTimezoneSelect({ showInnerLabel = true, selectId, embedded = false }) {
  const [value, setValue] = useState(getUserTimezone);
  useEffect(() => {
    const onChange = () => setValue(getUserTimezone());
    window.addEventListener('commray-timezone-change', onChange);
    return () => window.removeEventListener('commray-timezone-change', onChange);
  }, []);

  const rootClass = [
    'commray-settings-timezone',
    embedded && 'commray-settings-timezone--embedded'
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div
      className={rootClass}
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
      role="presentation"
    >
      {showInnerLabel ? <div className="commray-settings-timezone-label">Time zone</div> : null}
      <select
        id={selectId}
        className="commray-settings-timezone-select"
        value={value}
        onChange={(e) => setUserTimezone(e.target.value)}
        aria-label="Application time zone"
      >
        {TIMEZONE_OPTIONS.map((o) => (
          <option key={o.value || 'browser'} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
    </div>
  );
}
